// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var texture_url = require("./Texture_minecraft_1_18_1_items.png");

var texture = {
  id: "minecraft-1.18.1-items",
  url: texture_url,
  standardWidth: 512,
  standardHeight: 240
};

var tiles = [
  {
    name: "acacia_boat",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "acacia_door",
    x: 16,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "acacia_sign",
    x: 32,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "amethyst_shard",
    x: 48,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "apple",
    x: 64,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "armor_stand",
    x: 80,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "arrow",
    x: 96,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "axolotl_bucket",
    x: 112,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "baked_potato",
    x: 128,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bamboo",
    x: 144,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "barrier",
    x: 160,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "beef",
    x: 176,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "beetroot",
    x: 192,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "beetroot_seeds",
    x: 208,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "beetroot_soup",
    x: 224,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bell",
    x: 240,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "birch_boat",
    x: 256,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "birch_door",
    x: 272,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "birch_sign",
    x: 288,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "black_candle",
    x: 304,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "black_dye",
    x: 320,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "blaze_powder",
    x: 336,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "blaze_rod",
    x: 352,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "blue_candle",
    x: 368,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "blue_dye",
    x: 384,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bone",
    x: 400,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bone_meal",
    x: 416,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "book",
    x: 432,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bow",
    x: 448,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bow_pulling_0",
    x: 464,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bow_pulling_1",
    x: 480,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bow_pulling_2",
    x: 496,
    y: 0,
    width: 16,
    height: 16
  },
  {
    name: "bowl",
    x: 0,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "bread",
    x: 16,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "brewing_stand",
    x: 32,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "brick",
    x: 48,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "broken_elytra",
    x: 64,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "brown_candle",
    x: 80,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "brown_dye",
    x: 96,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "bucket",
    x: 112,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "bundle",
    x: 128,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "bundle_filled",
    x: 144,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "cake",
    x: 160,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "campfire",
    x: 176,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "candle",
    x: 192,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "carrot",
    x: 208,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "carrot_on_a_stick",
    x: 224,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "cauldron",
    x: 240,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chain",
    x: 256,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chainmail_boots",
    x: 272,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chainmail_chestplate",
    x: 288,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chainmail_helmet",
    x: 304,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chainmail_leggings",
    x: 320,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "charcoal",
    x: 336,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chest_minecart",
    x: 352,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chicken",
    x: 368,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "chorus_fruit",
    x: 384,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clay_ball",
    x: 400,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_00",
    x: 416,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_01",
    x: 432,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_02",
    x: 448,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_03",
    x: 464,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_04",
    x: 480,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_05",
    x: 496,
    y: 16,
    width: 16,
    height: 16
  },
  {
    name: "clock_06",
    x: 0,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_07",
    x: 16,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_08",
    x: 32,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_09",
    x: 48,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_10",
    x: 64,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_11",
    x: 80,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_12",
    x: 96,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_13",
    x: 112,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_14",
    x: 128,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_15",
    x: 144,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_16",
    x: 160,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_17",
    x: 176,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_18",
    x: 192,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_19",
    x: 208,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_20",
    x: 224,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_21",
    x: 240,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_22",
    x: 256,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_23",
    x: 272,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_24",
    x: 288,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_25",
    x: 304,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_26",
    x: 320,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_27",
    x: 336,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_28",
    x: 352,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_29",
    x: 368,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_30",
    x: 384,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_31",
    x: 400,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_32",
    x: 416,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_33",
    x: 432,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_34",
    x: 448,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_35",
    x: 464,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_36",
    x: 480,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_37",
    x: 496,
    y: 32,
    width: 16,
    height: 16
  },
  {
    name: "clock_38",
    x: 0,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_39",
    x: 16,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_40",
    x: 32,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_41",
    x: 48,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_42",
    x: 64,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_43",
    x: 80,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_44",
    x: 96,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_45",
    x: 112,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_46",
    x: 128,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_47",
    x: 144,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_48",
    x: 160,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_49",
    x: 176,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_50",
    x: 192,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_51",
    x: 208,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_52",
    x: 224,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_53",
    x: 240,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_54",
    x: 256,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_55",
    x: 272,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_56",
    x: 288,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_57",
    x: 304,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_58",
    x: 320,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_59",
    x: 336,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_60",
    x: 352,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_61",
    x: 368,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_62",
    x: 384,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "clock_63",
    x: 400,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "coal",
    x: 416,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "cocoa_beans",
    x: 432,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "cod",
    x: 448,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "cod_bucket",
    x: 464,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "command_block_minecart",
    x: 480,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "comparator",
    x: 496,
    y: 48,
    width: 16,
    height: 16
  },
  {
    name: "compass_00",
    x: 0,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_01",
    x: 16,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_02",
    x: 32,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_03",
    x: 48,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_04",
    x: 64,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_05",
    x: 80,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_06",
    x: 96,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_07",
    x: 112,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_08",
    x: 128,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_09",
    x: 144,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_10",
    x: 160,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_11",
    x: 176,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_12",
    x: 192,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_13",
    x: 208,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_14",
    x: 224,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_15",
    x: 240,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_16",
    x: 256,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_17",
    x: 272,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_18",
    x: 288,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_19",
    x: 304,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_20",
    x: 320,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_21",
    x: 336,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_22",
    x: 352,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_23",
    x: 368,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_24",
    x: 384,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_25",
    x: 400,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_26",
    x: 416,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_27",
    x: 432,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_28",
    x: 448,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_29",
    x: 464,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_30",
    x: 480,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "compass_31",
    x: 496,
    y: 64,
    width: 16,
    height: 16
  },
  {
    name: "cooked_beef",
    x: 0,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cooked_chicken",
    x: 16,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cooked_cod",
    x: 32,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cooked_mutton",
    x: 48,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cooked_porkchop",
    x: 64,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cooked_rabbit",
    x: 80,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cooked_salmon",
    x: 96,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cookie",
    x: 112,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "copper_ingot",
    x: 128,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "creeper_banner_pattern",
    x: 144,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crimson_door",
    x: 160,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crimson_sign",
    x: 176,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crossbow_arrow",
    x: 192,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crossbow_firework",
    x: 208,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crossbow_pulling_0",
    x: 224,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crossbow_pulling_1",
    x: 240,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crossbow_pulling_2",
    x: 256,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "crossbow_standby",
    x: 272,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cyan_candle",
    x: 288,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "cyan_dye",
    x: 304,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "dark_oak_boat",
    x: 320,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "dark_oak_door",
    x: 336,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "dark_oak_sign",
    x: 352,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond",
    x: 368,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_axe",
    x: 384,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_boots",
    x: 400,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_chestplate",
    x: 416,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_helmet",
    x: 432,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_hoe",
    x: 448,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_horse_armor",
    x: 464,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_leggings",
    x: 480,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_pickaxe",
    x: 496,
    y: 80,
    width: 16,
    height: 16
  },
  {
    name: "diamond_shovel",
    x: 0,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "diamond_sword",
    x: 16,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "dragon_breath",
    x: 32,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "dried_kelp",
    x: 48,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "egg",
    x: 64,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "elytra",
    x: 80,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "emerald",
    x: 96,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "empty_armor_slot_boots",
    x: 112,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "empty_armor_slot_chestplate",
    x: 128,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "empty_armor_slot_helmet",
    x: 144,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "empty_armor_slot_leggings",
    x: 160,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "empty_armor_slot_shield",
    x: 176,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "enchanted_book",
    x: 192,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "end_crystal",
    x: 208,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "ender_eye",
    x: 224,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "ender_pearl",
    x: 240,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "experience_bottle",
    x: 256,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "feather",
    x: 272,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "fermented_spider_eye",
    x: 288,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "filled_map",
    x: 304,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "filled_map_markings",
    x: 320,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "fire_charge",
    x: 336,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "firework_rocket",
    x: 352,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "firework_star",
    x: 368,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "firework_star_overlay",
    x: 384,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "fishing_rod",
    x: 400,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "fishing_rod_cast",
    x: 416,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "flint",
    x: 432,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "flint_and_steel",
    x: 448,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "flower_banner_pattern",
    x: 464,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "flower_pot",
    x: 480,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "furnace_minecart",
    x: 496,
    y: 96,
    width: 16,
    height: 16
  },
  {
    name: "ghast_tear",
    x: 0,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "glass_bottle",
    x: 16,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "glistering_melon_slice",
    x: 32,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "globe_banner_pattern",
    x: 48,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "glow_berries",
    x: 64,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "glow_ink_sac",
    x: 80,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "glow_item_frame",
    x: 96,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "glowstone_dust",
    x: 112,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "gold_ingot",
    x: 128,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "gold_nugget",
    x: 144,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_apple",
    x: 160,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_axe",
    x: 176,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_boots",
    x: 192,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_carrot",
    x: 208,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_chestplate",
    x: 224,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_helmet",
    x: 240,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_hoe",
    x: 256,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_horse_armor",
    x: 272,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_leggings",
    x: 288,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_pickaxe",
    x: 304,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_shovel",
    x: 320,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "golden_sword",
    x: 336,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "gray_candle",
    x: 352,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "gray_dye",
    x: 368,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "green_candle",
    x: 384,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "green_dye",
    x: 400,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "gunpowder",
    x: 416,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "heart_of_the_sea",
    x: 432,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "honey_bottle",
    x: 448,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "honeycomb",
    x: 464,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "hopper",
    x: 480,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "hopper_minecart",
    x: 496,
    y: 112,
    width: 16,
    height: 16
  },
  {
    name: "ink_sac",
    x: 0,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_axe",
    x: 16,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_boots",
    x: 32,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_chestplate",
    x: 48,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_door",
    x: 64,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_helmet",
    x: 80,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_hoe",
    x: 96,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_horse_armor",
    x: 112,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_ingot",
    x: 128,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_leggings",
    x: 144,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_nugget",
    x: 160,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_pickaxe",
    x: 176,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_shovel",
    x: 192,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "iron_sword",
    x: 208,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "item_frame",
    x: 224,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "jungle_boat",
    x: 240,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "jungle_door",
    x: 256,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "jungle_sign",
    x: 272,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "kelp",
    x: 288,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "knowledge_book",
    x: 304,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "lantern",
    x: 320,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "lapis_lazuli",
    x: 336,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "lava_bucket",
    x: 352,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "lead",
    x: 368,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather",
    x: 384,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_boots",
    x: 400,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_boots_overlay",
    x: 416,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_chestplate",
    x: 432,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_chestplate_overlay",
    x: 448,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_helmet",
    x: 464,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_helmet_overlay",
    x: 480,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_horse_armor",
    x: 496,
    y: 128,
    width: 16,
    height: 16
  },
  {
    name: "leather_leggings",
    x: 0,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "leather_leggings_overlay",
    x: 16,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light",
    x: 32,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_00",
    x: 48,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_01",
    x: 64,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_02",
    x: 80,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_03",
    x: 96,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_04",
    x: 112,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_05",
    x: 128,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_06",
    x: 144,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_07",
    x: 160,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_08",
    x: 176,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_09",
    x: 192,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_10",
    x: 208,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_11",
    x: 224,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_12",
    x: 240,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_13",
    x: 256,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_14",
    x: 272,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_15",
    x: 288,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_blue_candle",
    x: 304,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_blue_dye",
    x: 320,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_gray_candle",
    x: 336,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "light_gray_dye",
    x: 352,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "lime_candle",
    x: 368,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "lime_dye",
    x: 384,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "lingering_potion",
    x: 400,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "magenta_candle",
    x: 416,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "magenta_dye",
    x: 432,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "magma_cream",
    x: 448,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "map",
    x: 464,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "melon_seeds",
    x: 480,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "melon_slice",
    x: 496,
    y: 144,
    width: 16,
    height: 16
  },
  {
    name: "milk_bucket",
    x: 0,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "minecart",
    x: 16,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "mojang_banner_pattern",
    x: 32,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "mushroom_stew",
    x: 48,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_11",
    x: 64,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_13",
    x: 80,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_blocks",
    x: 96,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_cat",
    x: 112,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_chirp",
    x: 128,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_far",
    x: 144,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_mall",
    x: 160,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_mellohi",
    x: 176,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_otherside",
    x: 192,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_pigstep",
    x: 208,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_stal",
    x: 224,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_strad",
    x: 240,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_wait",
    x: 256,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "music_disc_ward",
    x: 272,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "mutton",
    x: 288,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "name_tag",
    x: 304,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "nautilus_shell",
    x: 320,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "nether_brick",
    x: 336,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "nether_sprouts",
    x: 352,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "nether_star",
    x: 368,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "nether_wart",
    x: 384,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_axe",
    x: 400,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_boots",
    x: 416,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_chestplate",
    x: 432,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_helmet",
    x: 448,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_hoe",
    x: 464,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_ingot",
    x: 480,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_leggings",
    x: 496,
    y: 160,
    width: 16,
    height: 16
  },
  {
    name: "netherite_pickaxe",
    x: 0,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "netherite_scrap",
    x: 16,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "netherite_shovel",
    x: 32,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "netherite_sword",
    x: 48,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "oak_boat",
    x: 64,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "oak_door",
    x: 80,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "oak_sign",
    x: 96,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "orange_candle",
    x: 112,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "orange_dye",
    x: 128,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "painting",
    x: 144,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "paper",
    x: 160,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "phantom_membrane",
    x: 176,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "piglin_banner_pattern",
    x: 192,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pink_candle",
    x: 208,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pink_dye",
    x: 224,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pointed_dripstone",
    x: 240,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "poisonous_potato",
    x: 256,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "popped_chorus_fruit",
    x: 272,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "porkchop",
    x: 288,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "potato",
    x: 304,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "potion",
    x: 320,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "potion_overlay",
    x: 336,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "powder_snow_bucket",
    x: 352,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "prismarine_crystals",
    x: 368,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "prismarine_shard",
    x: 384,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pufferfish",
    x: 400,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pufferfish_bucket",
    x: 416,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pumpkin_pie",
    x: 432,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "pumpkin_seeds",
    x: 448,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "purple_candle",
    x: 464,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "purple_dye",
    x: 480,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "quartz",
    x: 496,
    y: 176,
    width: 16,
    height: 16
  },
  {
    name: "rabbit",
    x: 0,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "rabbit_foot",
    x: 16,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "rabbit_hide",
    x: 32,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "rabbit_stew",
    x: 48,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "raw_copper",
    x: 64,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "raw_gold",
    x: 80,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "raw_iron",
    x: 96,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "red_candle",
    x: 112,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "red_dye",
    x: 128,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "redstone",
    x: 144,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "repeater",
    x: 160,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "rotten_flesh",
    x: 176,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "saddle",
    x: 192,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "salmon",
    x: 208,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "salmon_bucket",
    x: 224,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "scute",
    x: 240,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "sea_pickle",
    x: 256,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "seagrass",
    x: 272,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "shears",
    x: 288,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "shulker_shell",
    x: 304,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "skull_banner_pattern",
    x: 320,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "slime_ball",
    x: 336,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "snowball",
    x: 352,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "soul_campfire",
    x: 368,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "soul_lantern",
    x: 384,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spawn_egg",
    x: 400,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spawn_egg_overlay",
    x: 416,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spectral_arrow",
    x: 432,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spider_eye",
    x: 448,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "splash_potion",
    x: 464,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spruce_boat",
    x: 480,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spruce_door",
    x: 496,
    y: 192,
    width: 16,
    height: 16
  },
  {
    name: "spruce_sign",
    x: 0,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "spyglass",
    x: 16,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "spyglass_model",
    x: 32,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "stick",
    x: 48,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "stone_axe",
    x: 64,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "stone_hoe",
    x: 80,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "stone_pickaxe",
    x: 96,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "stone_shovel",
    x: 112,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "stone_sword",
    x: 128,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "string",
    x: 144,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "structure_void",
    x: 160,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "sugar",
    x: 176,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "sugar_cane",
    x: 192,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "suspicious_stew",
    x: 208,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "sweet_berries",
    x: 224,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "tipped_arrow_base",
    x: 240,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "tipped_arrow_head",
    x: 256,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "tnt_minecart",
    x: 272,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "totem_of_undying",
    x: 288,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "trident",
    x: 304,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "tropical_fish",
    x: 320,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "tropical_fish_bucket",
    x: 336,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "turtle_egg",
    x: 352,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "turtle_helmet",
    x: 368,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "warped_door",
    x: 384,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "warped_fungus_on_a_stick",
    x: 400,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "warped_sign",
    x: 416,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "water_bucket",
    x: 432,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "wheat",
    x: 448,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "wheat_seeds",
    x: 464,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "white_candle",
    x: 480,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "white_dye",
    x: 496,
    y: 208,
    width: 16,
    height: 16
  },
  {
    name: "wooden_axe",
    x: 0,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "wooden_hoe",
    x: 16,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "wooden_pickaxe",
    x: 32,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "wooden_shovel",
    x: 48,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "wooden_sword",
    x: 64,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "writable_book",
    x: 80,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "written_book",
    x: 96,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "yellow_candle",
    x: 112,
    y: 224,
    width: 16,
    height: 16
  },
  {
    name: "yellow_dye",
    x: 128,
    y: 224,
    width: 16,
    height: 16
  }
];

var data = [
  texture,
  tiles
];

exports.texture = texture;
exports.tiles = tiles;
exports.data = data;
/* texture Not a pure module */
